import { Student } from '../types';

export function normalizeStudentIdForCompare(id: string | number | null | undefined): string {
  if (id == null) return '';
  return String(id).trim().replace(/[.\-]/g, '').toUpperCase();
}

/** Compara IDs de estudiante tolerando formatos distintos (26134694K ↔ 26134694). */
export function studentIdsMatch(
  a: string | number | null | undefined,
  b: string | number | null | undefined
): boolean {
  if (a == null || b == null) return false;

  const sa = normalizeStudentIdForCompare(a);
  const sb = normalizeStudentIdForCompare(b);
  if (!sa || !sb) return false;
  if (sa === sb) return true;

  const na = Number(sa);
  const nb = Number(sb);
  if (!Number.isNaN(na) && !Number.isNaN(nb) && na === nb) return true;

  if (sa.endsWith('K') && sa.slice(0, -1) === sb) return true;
  if (sb.endsWith('K') && sb.slice(0, -1) === sa) return true;

  return false;
}

export function findStudentById<T extends { id: string | number; originalId?: string | number }>(
  students: T[],
  studentId: string | number | null | undefined
): T | undefined {
  if (studentId == null) return undefined;
  return students.find(s =>
    studentIdsMatch(s.id, studentId) ||
    (s.originalId != null && studentIdsMatch(s.originalId, studentId))
  );
}

export function isStudentIdSelected(
  selectedStudentIds: (string | number)[],
  studentId: string | number
): boolean {
  return selectedStudentIds.some(id => studentIdsMatch(id, studentId));
}

export function extractRutFromStudent(student: Student): string {
  if ((student as any).originalId) {
    const originalId = String((student as any).originalId);
    if (/^[0-9]{7,8}[0-9kK]$/i.test(originalId)) {
      return originalId.replace(/\./g, '').replace(/-/g, '');
    }
  }

  if ((student as any).metadata?.rut) {
    return (student as any).metadata.rut.replace(/\./g, '').replace(/-/g, '');
  }

  const studentIdStr = String(student.id);
  if (/^[0-9]{7,8}[0-9kK]$/i.test(studentIdStr)) {
    return studentIdStr.replace(/\./g, '').replace(/-/g, '');
  }

  const nameMatch = student.name.match(/\b[0-9]{1,2}\.[0-9]{3}\.[0-9]{3}-[0-9kK]\b/);
  if (nameMatch) {
    return nameMatch[0].replace(/\./g, '').replace(/-/g, '');
  }

  return studentIdStr;
}
